import React, { Fragment, useEffect, useState, useCallback } from "react"
import { useParams } from "react-router-dom"
import _ from "lodash"
import { Asterisk, Check, Globe, User as UserIcon, CircleUser } from "lucide-react"
import { useAppCtx, appStore } from "lib/state";
import { queryTools, cn } from "lib/utils";
import { GridTableButton, Menubar, Tabset, TagsManager } from "lib/components"
import { Forms } from "lib/components/forms"


export default function User(){

  const { uid } = useParams()
  const { appState } = useAppCtx()
  const { store, AppStore }:any = appStore()

  const { data:_User } = queryTools.resource.parseQueryForApi("user.findById", { _id: uid }, { enabled: !!uid })
  const saveMethod = queryTools.resource.save(["user.all"])

  const [ elementToCustomize, setElementToCustomize ] = useState<string>()
  const [ userFormData, setUserFormData ] = useState<any>({..._User})
  
  const saveUserConfig = async (newConfig:any) => {
    let userData = _.cloneDeep(_User)
    console.log(userData)
    saveMethod.mutate({ resource: "client", data: {...userData, ...userFormData} })
  }

  const handleInputChange = (e:any) => setUserFormData({ ...userFormData, [e.target.name]: e.target.value })

  const saveUser = () => {
    saveMethod.mutate({ resource: "user", data: _User._id } )
  }

  // useEffect(() => {

  // },[])

  if( !_User ) return <></>
  return(
    <div className="w-full h-full border border-solid border-slate-700 p-[2px]">
      <div className="w-full h-8 pl-6 pr-3 flex justify-between items-center bg-slate-700">
        <div className="w-3/12 flex items-center text-white text-sm uppercase">Edit User: { _User?.name }</div>
      </div>
      <div className="w-full flex flex-col px-4 py-2">
        
        <div className="w-full flex flex-col">
          <h3 className="w-full text-xl uppercase pb-1 pl-2 mb-4 border-b border-solid border-slate-700">Client Setup</h3>
          <div className="w-full flex gap-10">
              
            <Forms.Form className="w-full flex flex-col">
              <Forms.FieldGroup label="Name" className="w-full">
                <Forms.InputField 
                  type="text" 
                  name="name" 
                  value={userFormData.name} 
                  onChange={handleInputChange}  
                />
              </Forms.FieldGroup>

              <Forms.FieldGroup label="E-Mail" className="w-full">
                <Forms.InputField 
                  type="text" 
                  name="email" 
                  value={userFormData.email} 
                  onChange={handleInputChange}  
                />
              </Forms.FieldGroup>

              <Forms.FieldGroup className="mt-3 w-full flex flex-row justify-end gap-4">
                <button className="relative m-0 w-4/12 border border-solid border-teal-800 rounded h-10 px-4 bg-teal-900">Resend Credentials</button>
                <button className="relative m-0 w-4/12 border border-solid border-teal-800 rounded h-10 px-4 bg-teal-900">Save Changes</button>
              </Forms.FieldGroup>

            </Forms.Form>
          </div>
        </div>
      </div>
    </div>
  )
}